module.exports = __webpack_public_path__ + "static/media/SchoolCosSchoolReceive5.9bfe6642.png";